export default __webpack_public_path__ + "static/media/lucide.97c0858b.svg";